import { createContext } from 'react';

export const MobileAgents = [/Android/i, /webOS/i, /iPhone/i, /iPad/i, /iPod/i, /BlackBerry/i, /Windows Phone/i, /Kindle/i];

const UserAgentContext = createContext(null);
export default UserAgentContext;
